@if (tooltipType === 'template') {
  <ng-container *ngTemplateOutlet="_content; context: { entity: _context, index: _index }"></ng-container>
}
@if (tooltipType === 'string') {
  <div [innerHTML]="_content"></div>
}
